export const lookupInitialState = {
    data: [],
    industries: [],
    countries: [],
    states: [],
    cities: [],
    actions: [],
    govCategories: [],
    govOperators: [],
    govVersionStatuses: [],
    govFileDirections: [],
    govFileRuleTypes: [],
    govAppDispositions: [],
    errorMessage: "",
    loading: false
  }